module.exports = __webpack_public_path__ + "static/media/highway-4494907_640.f09ba2f2.jpg";